<template>

  <Form ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="labelWidth"
       >
<div><h2>信息保护设置</h2></div>

    <FormItem label="信息保护最大数量"
              prop="maxProtecNumber">
      <Input v-model="formValidate.maxProtecNumber"
             style="width:230px" />
    </FormItem>

    <FormItem label="信息保护时长(单位：分钟)"
              prop="maxProtecTime">
      <Input v-model="formValidate.maxProtecTime"
            style="width:230px" />
    </FormItem>

    <FormItem>
      <Button type="primary"
              @click="handleSubmit('formValidate')">保存设置</Button>
      <!-- <Button @click="fullUpdate()"
              style="margin-left: 8px">全量更新数据</Button> -->
    </FormItem>
  </Form>
</template>
<script>
export default {
  data () {
    return {
      labelWidth: 180,
      formValidate: {
        maxProtecNumber: 30,
        maxProtecTime: 200
      },
      ruleValidate: {
        maxProtecNumber: [
          {
            required: true,

            message: '数据不能为空',
            trigger: 'blur'
          }
        ],
        maxProtecTime: [
          {
            required: true,

            message: '数据不能为空',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created () {
    this.sysConfigGet();
  },
  mounted () {

  },

  methods: {
    handleSubmit (name) {
      console.log(this.formData);
      let _this = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$axios
            .request({
              url: 'caiji/?s=setting.sysConfigSet',
              data: _this.formValidate,

              method: 'POST'
            })
            .then(json => {
              console.log(json);
            });
          this.$Message.success('Success!');
        } else {
          this.$Message.error('Fail!');
        }
      });
    },
    sysConfigGet () {
      this.$axios
        .request({
          url: 'caiji/?s=setting.sysConfigGet',
          method: 'GET'
        })
        .then(json => {
          let data = json.data.data;
          this.formValidate.maxProtecNumber = data.max_protec_number;
          this.formValidate.maxProtecTime = data.max_protec_time;
          // console.log('sysConfig', json);
        });
    }
  }
};
</script>
